import React from "react";

export default function BaseButton({
  inlineStyle: additionalStyles,
  className,
  type,
  disabled,
  children,
  ...rest
}) {
  return (
    <button
      className={`${className} inline-flex items-center justify-center relative`}
      rol="button"
      type={type}
      style={Object.assign({ outline: "none" }, { ...additionalStyles })}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
}



// WEBPACK FOOTER //
// ./src/BaseButton/BaseButton.js